module.exports = __webpack_public_path__ + "media/step_3_en.e868c736.mp3";